import { useCallback, useMemo } from 'react';
import ExperimentService from 'business/services/ExperimentService';
import { useModalHandlers } from 'components/modal';
import { downloadFile, GetCaptureProfileTuningValues } from 'utils/Global';
import {
  useLastSelectedWellNavigationDetails,
  useSelectedDropImageParameters,
} from 'redux/hooks/experiment';

type ExportFrapDataPoints = [exportFrapDataPoints: () => void, isFrap: boolean];

const useFrapDataPointsExport = (): ExportFrapDataPoints => {
  const { showModal, showLoadingModal, hideModal } = useModalHandlers();
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const { plateID } = wellNavigationDetails || {};
  const { inspection, cpId, dropNumber } = selectedDropImageParameters || {};
  const imageBatchId = inspection?.groupedInspections?.find(
    (gi) => gi.plateId === plateID,
  )?.imageBatchId;

  const isFrap = useMemo(() => {
    const captureProfileTuningValues = GetCaptureProfileTuningValues();
    if (cpId) {
      if (captureProfileTuningValues !== undefined && captureProfileTuningValues.length) {
        const cp = captureProfileTuningValues.find(
          (cptv) => cptv.captureProfileID === cpId,
        );
        return cp?.isFrap;
      } else {
        return false;
      }
    }
  }, [cpId]);

  const exportFrapDataPoints = useCallback(async () => {
    showLoadingModal('Loading...');
    const experimentService = new ExperimentService();
    const res = await experimentService.exportFrapData(
      plateID,
      imageBatchId,
      cpId,
      dropNumber,
    );
    hideModal();
    if (!res?.value || !res?.value.length) {
      showModal({
        body: "This experiment doesn't have frap data point.",
        onOk: hideModal,
        heading: 'Export Frap Data Point',
        dialogClassName: 'min-w-[500px] m-0',
        okButtonText: 'Ok',
        isCancelOnly: false,
        isOkOnly: true,
      });
    } else {
      downloadFile(
        new Blob([res.value]),
        `frap_${plateID}_${dropNumber}_${cpId}_${imageBatchId}.csv`,
      );
    }
  }, [plateID, cpId, imageBatchId, dropNumber]);

  return [exportFrapDataPoints, isFrap];
};

export default useFrapDataPointsExport;
